<template>
    <div>
        <h2 class="title is-4">
            Works Orders
        </h2>

        <h4 class="subtitle is-6 mb-5">
            Listed below are the works orders assigned to this estate.
        </h4>

        <DateSearchForm
            :from-date.sync="fromDate"
            :to-date.sync="toDate"
            :minimum-date="minimumDate"
            @search="searchWorksOrders"
        />

        <Notification v-if="worksOrders && ! hasWorksOrders">
            No Works Orders found.
        </Notification>

        <div
            v-else
            class="table-container"
        >
            <table class="table is-fullwidth is-bordered is-striped">
                <thead v-if="! worksOrders || hasWorksOrders">
                    <tr>
                        <th class="is-hidden-mobile is-hidden-tablet-only">
                            Date
                        </th>
                        <th>
                            Description
                        </th>
                        <th>
                            Estimate
                        </th>
                        <th>
                            Status
                        </th>
                        <th>
                            Date Completed
                        </th>
                    </tr>
                </thead>
                <tbody v-if="hasWorksOrders">
                    <LeaseholdWorksOrderRow
                        v-for="row in worksOrders.Rows"
                        :key="row.WorksOrderPK"
                        :row="row"
                    />
                </tbody>
                <SkeletonRow
                    v-if="! worksOrders && ! hasWorksOrders"
                    :row-count="3"
                    :desktop-count="5"
                    :tablet-count="5"
                    :mobile-count="5"
                />
            </table>
        </div>

        <b-pagination
            v-if="hasWorksOrders && worksOrders.RowCount > limit"
            class="mt-3"
            :total="worksOrders.RowCount"
            :current.sync="page"
            order="is-centered"
            range-before="2"
            range-after="2"
            :per-page="limit"
            @change="searchWorksOrders(false)"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Notification from './Notification.vue';
import SkeletonRow from './SkeletonRow.vue';
import LeaseholdWorksOrderRow from './LeaseholdWorksOrderRow';
import DateSearchForm from './DateSearchForm';

export default {
    components: {
        Notification,
        SkeletonRow,
        LeaseholdWorksOrderRow,
        DateSearchForm,
    },

    data: function() {
        const { query } = this.$route;

        return {
            page: Number(this.$route.query.page || 1),
            limit: 12,
            fromDate: query.fromDate ? this.$dayjs.unix(query.fromDate).toDate() : this.$dayjs().subtract(1, 'year').toDate(),
            toDate: query.toDate ? this.$dayjs.unix(query.toDate).toDate() : this.$dayjs().toDate(),
        };
    },

    computed: {
        ...mapState('leaseholdProperty', [
            'property',
        ]),
        ...mapState('leaseholdWorksOrders', [
            'worksOrders',
        ]),
        ...mapGetters('leaseholdWorksOrders', [
            'hasWorksOrders',
        ]),
        minimumDate() {
            return this.$meta.features.leaseholders.works_orders_from;
        },
        isSearchBeforeMinimumDate() {
            return (this.minimumDate && this.$dayjs(this.fromDate).isBefore(this.$dayjs(this.minimumDate)));
        },
        queryParams() {
            return {
                ...this.$data,
                // change format of dates to timestamp
                fromDate: this.$dayjs(this.fromDate).unix(),
                toDate: this.$dayjs(this.toDate).unix(),
            };
        },
        queryParamsString() {
            const params = new URLSearchParams(this.queryParams);
            return params.toString();
        },
    },

    mounted() {
        this.getWorksOrders();
    },

    methods: {
        searchWorksOrders(resetPagination = true) {
            if (resetPagination) {
                this.page = 1;
            }

            this.$router.push({
                query: this.queryParams,
            });

            this.getWorksOrders();
        },
        getWorksOrders() {
            this.$store.dispatch('leaseholdWorksOrders/getWorksOrders', {
                propertyPK: this.property.PropertyPK,
                params: this.$data,
            });
        },
    },
};
</script>
